import React from 'react'
import Fixed from './Fixed'
//import Firstimage from './Firstimage'
//import Catagories from './Catagories'
import Brands from './Brands'
import Connect from './Connect'
//import Work from './Work'
//import Why from './Why'
//import Footer from './Footer'
import Landing from './Landing'
import Services from './Services'
import Footer1 from './Footer1'
import JPay from './Jpay';
import Clients from './Clients'
import Testimonials from './Testimonials'

const Body = () => {
  return (
    <div>
        <div className="fixed w-full z-10">
        <Fixed />
        </div>

        <Landing />
        <JPay />
        <Services />
        <Brands />
        <Connect />
        <Clients />
        <Testimonials />
        <Footer1 />

    </div>
  )
}

export default Body